var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/48px/Actions"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5552 48.7551L25.0003 50L26.4537 48.7634C28.4378 47.0788 45.8337 31.9806 45.8337 20.9366C45.8337 9.37364 36.5062 0 25.0003 0C13.4944 0 4.16699 9.37364 4.16699 20.9366C4.16699 31.9805 21.5629 47.0787 23.5552 48.7551ZM8.67186 20.9365C8.68207 11.8781 15.9866 4.53735 25.0003 4.52709C34.0142 4.53745 41.3186 11.8781 41.3288 20.9365C41.3288 27.8661 30.6263 38.9559 25.0003 44.0307C19.3745 38.9579 8.67186 27.8745 8.67186 20.9365ZM16.7423 20.9366C16.7423 25.52 20.4396 29.2356 25.0004 29.2356C29.5614 29.2356 33.2586 25.52 33.2586 20.9366C33.2586 16.3531 29.5613 12.6375 25.0004 12.6375C20.4396 12.6375 16.7423 16.3531 16.7423 20.9366ZM20.8713 20.9365C20.8713 18.6447 22.72 16.7869 25.0004 16.7869C27.2809 16.7869 29.1295 18.6447 29.1295 20.9365C29.1295 23.2282 27.2808 25.086 25.0004 25.086C22.72 25.086 20.8713 23.2282 20.8713 20.9365Z",
    fill: "#3C5BD2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocation);
export default __webpack_public_path__ + "static/media/ic_location.c25226d51f12530b5a5d7cfe0d157eeb.svg";
export { ForwardRef as ReactComponent };